import * as Ladda from 'ladda';
import flatpickr from 'flatpickr';
import { Italian } from 'flatpickr/dist/l10n/it';
import tracking from 'tracking';
import 'tracking/build/data/face';
import FormUtils from './utils/FormUtils';
import { ImageUtils, ResourceUtils, CropUtils } from './utils/ResourceUtils';
import StringUtils from './utils/StringUtils';
import DateUtils from './utils/DateUtils';

flatpickr.localize(Italian);

export function LoaderShow() {
	document.querySelector('body').classList.add('page-loader-show');
	const insertInside = '.page-loader';
	const loaderHtml = `
   <div class="loader-overlay">
      <div class="loader-content">
      <div class="loader-index">
         <div></div>
         <div></div>
         <div></div>
         <div></div>
         <div></div>
         <div></div>
      </div>
      </div>
   </div>`;

	function isEmptyObject(insertInside) {
		return document.querySelectorAll(insertInside).length === 0;
	}

	if (!isEmptyObject(insertInside)) {
		let target = document.querySelector(insertInside);
		if (target) target.insertAdjacentHTML('beforeend', loaderHtml);
	}
}

/**
 * Remove loader
 */
export function LoaderHide() {
	let el = document.querySelector('.loader-overlay');
	if (!el) return;
	document.querySelector('body').classList.remove('page-loader-show');
	el.parentNode.removeChild(el);
}

export function copyOnClipboard(selector, message = 'Contenuto copiato') {
	const copyText = selector instanceof Element ? selector : document.getElementById(selector);
	const content = copyText.getAttribute('data-copy');
	if (!content || content === '') return;
	// Copy the text inside the text field
	navigator.clipboard.writeText(copyText.getAttribute('data-copy'));
	if (toastr && message) {
		toastr.success(message);
	}
}

export function emptyClipboard() {
	navigator.clipboard.writeText('');
}

export { FormUtils };

export { ResourceUtils };

export { ImageUtils };

export { CropUtils };

export { StringUtils };

export function getLastVersion() {
	const lastVersion = localStorage.getItem('naxos-version');
	if (!lastVersion) {
		setLastVersion();
	}
	return localStorage.getItem('naxos-version');
}

export function setLastVersion(version = null) {
	console.info('Aggiornamento versione locale', version);
	localStorage.setItem('naxos-version', version ?? window.version);
}

export function checkForUpdates() {
	if (getLastVersion() !== window.version) {
		$('#last-updates-button').show();
	} else {
		$('#last-updates-button').hide();
	}
}

export function openLastUpdatesWindow(url) {
	const lastVersion = getLastVersion();
	createAndOpenPanel(url + '?current_version=' + window.version + (lastVersion ? '&version=' + lastVersion : ''));
}

export function createAndOpenPanel(url, reload = false) {
	// Create the overlay
	const overlay = document.createElement('div');
	overlay.id = 'overlay';
	overlay.style.position = 'fixed';
	overlay.style.top = 0;
	overlay.style.left = 0;
	overlay.style.width = '100%';
	overlay.style.height = '100%';
	overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
	overlay.style.zIndex = 9999;

	// Create the panel
	const panel = document.createElement('div');
	panel.id = 'panel';
	panel.style.position = 'fixed';
	panel.style.top = '50%';
	panel.style.left = '50%';
	panel.style.transform = 'translate(-50%, -50%)';
	panel.style.width = '90%';
	panel.style.height = '90%';
	panel.style.backgroundColor = '#fff';
	panel.style.zIndex = 10000;

	// Create the iframe
	const iframe = document.createElement('iframe');
	iframe.src = url;
	iframe.style.width = '100%';
	iframe.style.height = '100%';
	iframe.style.border = 'none';
	iframe.style.display = 'block';
	iframe.style.margin = '0 auto';

	// Create the close button
	const closeButton = document.createElement('div');
	closeButton.id = 'close-popup';
	closeButton.className = 'btn-default btn btn-floating back-link';
	closeButton.title = 'Chiudi';
	closeButton.setAttribute('data-toggle', 'tooltip');
	closeButton.setAttribute('data-original-title', 'Chiudi');

	const closeIcon = document.createElement('i');
	closeIcon.className = 'icon fa-solid fa-xmark';
	closeIcon.setAttribute('aria-hidden', 'true');

	closeButton.appendChild(closeIcon);
	closeButton.style.position = 'absolute';
	closeButton.style.top = '5px';
	closeButton.style.left = '5px';
	closeButton.style.width = '3rem';
	closeButton.style.height = '3rem';
	closeButton.style.cursor = 'pointer';
	closeButton.style.color = '#76838f !important';

	// Append elements
	panel.appendChild(iframe);
	panel.appendChild(closeButton);
	overlay.appendChild(panel);
	document.body.appendChild(overlay);

	function closePopup() {
		document.body.removeChild(overlay);
		window.dispatchEvent(new CustomEvent('popup-closed'));
		if (reload) {
			window.location.reload();
		} else {
			console.info('Chiusura comunicazione con popup');
			window.removeEventListener('message', messageHandler);
		}
	}

	function messageHandler(event) {
		if (event.data === 'allowClose' || event.data === 'preventClose') {
			if (event.data === 'allowClose') {
				closePopup();
			} else if (event.data === 'preventClose') {
				const confirmClose = window.confirm('Potrebbe esserci del lavoro non salvato. Sei sicuro di voler chiudere la pagina?');
				if (confirmClose) {
					//iframe.contentWindow.needsConfirm = false;
					iframe.contentWindow.postMessage({ action: 'setNeedsConfirm', value: false }, '*');
					iframe.contentWindow.postMessage('requestClose', '*');
				}
			}
		} else if (event.data === 'ping') {
			console.info('handshake window/popup effettuato');
			iframe.contentWindow.postMessage('pong', '*');
		} else if (event.data === 'changelogRead') {
			setLastVersion(window.version);
			checkForUpdates();
		}
	}

	window.addEventListener('message', messageHandler);

	console.info('Inizializzato protocollo richiesta requestClose');

	closeButton.addEventListener('click', function () {
		iframe.contentWindow.postMessage('requestClose', '*');
	});
}

export { DateUtils };
